import { render } from "./ModalDetails.vue?vue&type=template&id=0c122746&ts=true"
import script from "./ModalDetails.vue?vue&type=script&lang=ts"
export * from "./ModalDetails.vue?vue&type=script&lang=ts"

import "./ModalDetails.vue?vue&type=style&index=0&id=0c122746&lang=css"

import exportComponent from "C:\\wamp64\\www\\sisdeu\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__